var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgKpmgTrasabilityDisabled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 28,
    viewBox: "0 0 32 28"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".kpmg-trasability-disabled_svg__cls-2,.kpmg-trasability-disabled_svg__cls-3{fill:#fff;stroke-width:.4px;stroke:#fff}.kpmg-trasability-disabled_svg__cls-3{fill:none;stroke-linecap:round;stroke-width:1.6px}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "kpmg-trasability-disabled_svg__ICN_FTrasabilitate_Disabled",
    transform: "translate(-166 -232)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "kpmg-trasability-disabled_svg__Polygon_11",
    "data-name": "Polygon 11",
    d: "M21.679 0a4 4 0 013.473 2.015l5.714 10a4 4 0 010 3.969l-5.714 10A4 4 0 0121.679 28H10.321a4 4 0 01-3.473-2.015l-5.714-10a4 4 0 010-3.969l5.714-10A4 4 0 0110.321 0z",
    transform: "translate(166 232)",
    fill: "#e5e2e2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "kpmg-trasability-disabled_svg__ICN_Trasabilitate_Active",
    transform: "translate(54.796 86.026)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "kpmg-trasability-disabled_svg__Group_1223",
    "data-name": "Group 1223",
    transform: "rotate(-11 859.831 -525.15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "kpmg-trasability-disabled_svg__Path_886",
    "data-name": "Path 886",
    className: "kpmg-trasability-disabled_svg__cls-2",
    d: "M4.507 2.27L2.27 4.507a.445.445 0 01-.63 0L.572 3.438A1.962 1.962 0 01.571.67l.1-.1a1.962 1.962 0 012.768 0l1.068 1.071a.445.445 0 010 .629zM2.808 1.2a1.071 1.071 0 00-1.508 0l-.1.1a1.071 1.071 0 000 1.509l.754.754 1.608-1.608z",
    transform: "rotate(-135.97 5.528 6.41)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-trasability-disabled_svg__Path_887",
    "data-name": "Path 887",
    className: "kpmg-trasability-disabled_svg__cls-2",
    d: "M.408 4.26a5.285 5.285 0 00-.37-1.389.445.445 0 01.092-.494L2.377.13a.445.445 0 01.517-.082 7.635 7.635 0 012.559 2.4 7.527 7.527 0 011.4 3.357 2.8 2.8 0 01-.49 2.223 1.712 1.712 0 01-1.317.545 4.639 4.639 0 01-2.717-1.17A4.283 4.283 0 01.408 4.26zm4.64 3.427a.827.827 0 00.654-.25A2.031 2.031 0 005.97 5.9 7.794 7.794 0 002.768 1L.969 2.8a5.553 5.553 0 01.247.9l.445-.445a.445.445 0 11.63.63l-.876.876a3.65 3.65 0 001.477 1.955 3.829 3.829 0 002.157.971z",
    transform: "rotate(-135.97 4.691 4.476)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-trasability-disabled_svg__Line_140",
    "data-name": "Line 140",
    className: "kpmg-trasability-disabled_svg__cls-3",
    transform: "translate(131.109 168.475)",
    d: "M2.095 0H0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-trasability-disabled_svg__Line_141",
    "data-name": "Line 141",
    className: "kpmg-trasability-disabled_svg__cls-3",
    transform: "translate(130.411 164.474)",
    d: "M2.793 0H0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-trasability-disabled_svg__Line_142",
    "data-name": "Line 142",
    className: "kpmg-trasability-disabled_svg__cls-3",
    transform: "translate(130.411 156.475)",
    d: "M2.793 0H0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-trasability-disabled_svg__Line_144",
    "data-name": "Line 144",
    className: "kpmg-trasability-disabled_svg__cls-3",
    transform: "translate(131.109 152.476)",
    d: "M1.397 0H0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-trasability-disabled_svg__Line_147",
    "data-name": "Line 147",
    className: "kpmg-trasability-disabled_svg__cls-3",
    transform: "translate(131.109 160.475)",
    d: "M1.397 0H0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-trasability-disabled_svg__Line_148",
    "data-name": "Line 148",
    className: "kpmg-trasability-disabled_svg__cls-3",
    transform: "translate(133.204 152.474)",
    d: "M0 0v15"
  })))));
}

export default SvgKpmgTrasabilityDisabled;